import { COOKIE_NAMES } from '@intigral/constant';
import config from './config.json';

export const MIN_SEARCH_CHARS = 3;

export const GRACE_PERIOD_HOME_POPUP_DISMISSED_KEY = 'wcp_grace_period_home_popup_dismissed';

export const CUSTOM_EVENTS = {
    SEARCH: {
        GLOBAL_SEARCH_OPEN: 'openGlobalSearch',
    },
};

export { STORE_NAME } from '@intigral/constant';

export const DRM_URL_TYPE = {
    PLAYREADY: 'playReadyLicenceUrl',
    WIDEVINE: 'widevineLicenceUrl',
    FAIRPLAY: 'fairplayLicenseUrl',
};

export const menuTypes = {
    HEADER: 'header',
    FOOTER: 'footer',
    IMAGES: 'images',
    FILTERS: 'listFilter',
    CHAT: 'chat',
    USER: 'user',
};

export const dataStreamTypes = {
    PROMOTIONS: 'promo_list',
    VOD_LIST: 'vod_list',
    VOD_DETAILS: 'vod_details',
    CAST_CREW: 'cast_crew',
    VOD_MORE_LIKE_THIS: 'vod_more_like_this',
    REWIND: 'rewind',
    REWIND_PAGE: 'rewind_page',
    MORE_LIKE_THIS: 'more_like_this',
    SEARCH: 'search',
    PROFILE_SETTINGS: 'profile_settings',
    USER_DEVICES: 'user_devices',
    CHANNELS: 'channels',
    SEASONS: 'seasons',
    CONTINUE_WATCHING: 'continue_watching',
    USER_MINI_EPG: 'user_mini_epg',
    DIVE_TRENDING: 'dive_trending',
    DIVE_TOP_PICKS: 'dive_top_picks',
    BIOGRAPHY: 'biography',
    LAST_CHANCE_TO_WATCH: 'dive_last_chance_to_watch',
    WATCH_AGAIN: 'watch_again',
    BECAUSE_YOU_WATCHED: 'because_you_watched',
    BECAUSE_YOU_WATCH: 'because_you_watch',
    TA_LIST: 'ta_list',
    TA_MORE_LIKE_THIS: 'ta_more_like_this',
    TA_BECAUSE_YOU_WATCH: 'ta_because_you_watch',
    TA_BECAUSE_YOU_WATCH_MULTIPLE: 'byw',
    TA_MORE_LIKE_THIS_OTHERS: 'others_more_like_this',
    MOODS_RECOMMENDATION: 'moods_recommendation',
};

export const defaultDataStream = {
    TV_SERIES_DETAILS: 'mpx_tv_series',
    VOD_DETAILS: 'mpx_all_vods',
    DIVE_MORE_LIKE_THIS: 'dive_more_like_this',
    ALL_VOD_ASSETS: 'mpx_all_assets',
    MPX_ALL_PERSONS: 'mpx_all_persons',
    BIOGRAPHY: 'biography',
    FILMOGRAPHY: 'filmography',
    THINK_ANALYTICS_MORE_LIKE_THIS: 'think_analytics_more_like_this',
    THINK_ANALYTICS_CUSTOM_ENDPOINT: 'think_analytics_custom_endpoint',
    RENTED_TVOD: 'rented_tvod',
};

export default {
    DEFAULT_LANGUAGE: config.defaultLanguage,
    DEFAULT_SCREEN: config.defaultScreen,
    LANG_LTR: 'ltr',
    LANG_RTL: 'rtl',
    LANG_AR: 'ar',
    LANG_EN: 'en',
    WATCHLIST_BUTTON_TYPE_LARGE: 'large',
    WATCHLIST_BUTTON_TYPE_SMALL: 'small',
    SCREEN_HISTORY_STORE: 'screenHistory',
};

export const possibleLanguages = ['ar', 'en', 'fr'];

export const profileConstants = {
    DEFAULT_PROFILE_NAME: 'Default',
    RATING_FAMILY: 'G',
    RATING_R18: 'R18',
    RATING_18: '18',
    RATING_R15: 'R15',
    RATING_PG: 'PG',
};

export const screenDetailTypes = {
    MOVIES: 'movie',
    SERIES: 'series',
    SEARCH: 'search',
    EPISODE: 'episode',
    PROFILE_SETTINGS: 'userProfileScreen',
    PROFILE_SELECT: 'selectProfileScreen',
};

export const configTypes = {
    CONFIGURATION_ALL: 'config.configuration',
    DETAIL_SCREENS: 'detailScreens',
    EXTERNAL_LINKS: 'config.configuration.appConfig.externalLinks',
    API: 'config.configuration.api',
    GEOLOCATION_RESTRICTIONS: 'config.configuration.geolocationRestriction',
    SCREENS: 'screens',
    API_JAWWY_PARENTAL: 'api_resources.users_parental',
    API_JAWWY_CREATE_PROFILE: 'api_resources.users_create_profile',
    API_BOLT_WATCHLIST: 'api_resources.users_watchlist',
    API_JAWWY_WATCHLIST_ADD_VOD: 'api_resources.add_users_watchlist_vod',
    API_JAWWY_WATCHLIST_REMOVE_VOD: 'api_resources.remove_users_watchlist_vod',
    API_JAWWY_WATCHLIST_ADD_LINEAR: 'api_resources.add_users_watchlist_linear',
    API_JAWWY_WATCHLIST_REMOVE_LINEAR: 'api_resources.remove_users_watchlist_linear',
    API_BOLT_USER_DEVICE: 'api_resources.users_devices',
    API_BOLT_USER_REFRESH_TOKEN: 'api_resources.users_auth_refresh_token',
    API_BOLT_VALIDATE_PASSWORD: 'api_resources.validate_password',
    API_BOLT_SUBSCRIPTION_STATUS: 'api_resources.supscription_status',
    API_USER_BOOKMARKS: 'api_resources.user_bookmarks',
    API_JAWWY_GET_PROFILES: 'api_resources.get_profiles',
    API_JAWWY_ADD_PROFILE: 'api_resources.add_profile',
    API_JAWWY_UPDATE_PROFILE: 'api_resources.update_profile',
    API_JAWWY_DELETE_PROFILE: 'api_resources.delete_profile',
    API_JAWWY_SWITCH_PROFILE: 'api_resources.switch_profile',
    API_JAWWY_USER_REVISION: 'api_resources.user_revision',
    API_JAWWY_CHANNELS: 'api_resources.data_channels',
    API_JAWWY_STREAM_CONCURRENCY: 'api_resources.stream_concurrency',
    API_JAWWY_STREAM_CONCURRENCY_CLEAR_CACHE: 'api_resources.stream_concurrency_clear_cache',
    API_JAWWY_PRICING_TEMPLATES: 'api_resources.get_pricing_templates',
    API_JAWWY_ONE_TIME_PURCHASE: 'api_resources.onetime_purchase',
    API_JAWWY_OTP_ONETIME_PURCHASE: 'api_resources.otp_onetime_purchase',
    API_JAWWY_FORGET_PASSWORD: 'api_resources.forget_password',
    API_JAWWY_OTP_ONETIME_VERIFY: 'api_resources.otp_onetime_verify',
    API_JAWWY_CREATE_PARENTAL_PIN: 'api_resources.create_parental_pin',
    API_JAWWY_UPDATE_PARENTAL_PIN: 'api_resources.update_parental_pin',
    API_JAWWY_GET_PARENTAL_PIN: 'api_resources.get_parental_pin',
    API_JAWWY_VALIDATE_PARENTAL_PIN: 'api_resources.validate_parental_pin',
    API_JAWWY_QITAF_OTP_GENERATE: 'api_resources.qitaf_otp_generate',
    API_JAWWY_QITAF_OTP_VERIFY: 'api_resources.qitaf_otp_verify',
    API_JAWWY_GET_STREAMS: 'api_resources.get_streams',
    API_RECOMMENDATION_LEARN_ACTION: 'api_resources.learn_action',
    API_RECOMMENDATION_SEARCH_CLICK: 'api_resources.search_click',
    API_JAWWY_CHANNELS_HISTORY: 'api_resources.user_channel_history',
    API_JAWWY_SEASON_HISTIRY: 'api_resources.series_history',
    API_JAWWY_KIDS_ACCOUNT_RETRIEVAL_GENERATE_OTP: 'api_resources.kids_account_retrieval_generate_otp',
    API_JAWWY_KIDS_ACCOUNT_RETRIEVAL_VERIFY_OTP: 'api_resources.kids_account_retrieval_verify_otp',
};

export const apiVars = {
    API_KEY: 'apikey',
    USER_TOKEN: 'token',
};

export const ItemPosition = {
    First: 0,
    Mid: 1,
    Last: 2,
};

export const ButtonTypes = {
    VodeItem: 'VodeItem',
    VodFeaturedItem: 'VodFeaturedItem',
    VodDetails: 'VodDetails',
    SeriesDetails: 'SeriesDetails',
    RewindItem: 'RewindItem',
    EpisodeItem: 'EpisodeItem',
    LinearItem: 'Linear',
    ContinueWatching: 'ContinueWatching',
    WatchlistCarouselItem: 'WatchlistCarouselItem',
    SearchRecommendations: 'SearchRecommendations',
    TvGuideCarouselItemLive: 'GuideTvCarouselItemLive',
    TvGuideCarouselItemRewind: 'GuideTvCarouselItemRewind',
    ProgramItem: 'ProgramItem',
    RewindListProgramItem: 'RewindListProgramItem',
    ModalItem: 'ModalItem',
    Stream: 'Stream',
    SeasonItem: 'SeasonItem',
    NextEpisode: 'NextEpisode',
    TVodItem: 'TVodItem',
    PPVItem: 'PPVItem',
    IsTVODItem: 'IsTVODItem',
    PPV: 'PPV',
};

export const playerTypes = {
    Trailer: 'Trailer',
    LiveTV: 'LiveTV',
    Vod: 'Vod',
    Series: 'Series',
    Catchup: 'Catchup',
    PlayTrailer: 'PlayTrailer',
    Outstream: 'Outstream',
};

export const errorCodes = {
    EXPIRED_TOKEN: '9006',
    INVALID_PROFILE_NAME: '9005',
    TOKEN_NOT_BELONG_TO_USERNAME: '6003',
    MAX_DEVICES: '2010',
    DEVICE_REMOVE_AFTER_30DAYS: '2011',
    DEFAULT_PROFILE_CANT_DELETE: '9027',
    MAX_PROFILE_LIMIT: '8080',
    PROFILE_NAME_EXISTS: '9024',
    PROFILE_NAME_DEFAULT_ERROR: '9032',
};

export const masonryBreakpoints = {
    default: 6,
    1365: 4,
    1023: 3,
    767: 2,
};

export const rewindBreakpoints = {
    default: 4,
    991: 3,
    767: 2,
};

export const apiPaths = {
    USER_CHANNELS: 'users_channels',
    DATA_CHANNELS: 'data_channels',
    DATA_KIDS_CHANNELS: 'data_kids_channels',
    CHANNEL_SCHEDULE: 'channel_schedule',
    MINIEPG_CHANNELS: 'jawwy_user_mini_epg',
};

export const ratingControls = {
    G: 'G',
    PG: 'PG',
    PG12: 'PG12',
    PG15: 'PG15',
    R15: 'R15',
    R18: 'R18',
};

export const errorMessage = {
    MSG_EN: 'We are facing an unexpected error and trying to fix it. Please check back soon.',
    MSG_AR: 'نواجه خطأ غير متوقع ونحاول إصلاحه. يرجى التحقق مجدداً قريباً.',
};
export const overlayMessage = {
    MSG_TITLE_EN: 'We Miss You',
    MSG_TEXT_EN:
        'We have added tons of new content to our catalog with a mix of movies, TV shows and Kid’s entertainment. So now is a great time to come back!',
    MSG_BUTTON_EN: 'Renew Your subscription',
    MSG_TITLE_AR: 'إننا نفتقدك',
    MSG_TEXT_AR:
        'لقد أضفنا الكثير من المحتوى الجديد إلى كتالوجنا بمزيج من الأفلام والبرامج التلفزيونية والترفيه للأطفال. حتى الآن هو الوقت المناسب للعودة!',
    MSG_BUTTON_AR: 'تجديد اشتراكك',
};

export const errorConstants = {
    STREAM_ERROR: 'STREAM_ERROR',
    ENTITLEMENT_VALIDATION_ERROR: 'EntitlementValidationError',
};

export const userStatus = {
    OPERATOR: 'DEFAULT',
};

export const customLoggingLevels = {
    NONE: -1,
    LOG: 0,
    DEBUG: 1,
    INFO: 2,
    WARN: 3,
    ERROR: 4,
};

export const ITEM_TYPE = {
    LIVE: 'Live',
    REWIND: 'Rewind',
    MOVIE: 'Movie',
    SERIES: 'Series',
    EPISODE: 'Episode',
    PERSON: 'Person',
    VOD: 'Movie',
};

export const PROGRAM_TYPE = {
    MOVIE: 'movie',
    SERIES: 'series',
    EPISODE: 'episode',
};

export const cookiesNames = {
    USER_SESSION: COOKIE_NAMES.USER_SESSION,
    USER_LOGIN_ATTEMPT: '_lgatt',
};

export const deviceTypes = {
    MOBILE: ['ANDROID', 'IPHONE', 'ANDROID_CC', 'APPLE_AR', 'Smartphone'],
    TABLET: ['ANDROID', 'IPHONE', 'ANDROID_CC', 'APPLE_AR', 'Tablet'],
    WEB: [
        'wcp',
        'wcp_safari',
        'wcp_firefox',
        'wcp_chrome',
        'wcp_edge',
        'web',
        'web_safari',
        'web_firefox',
        'web_chrome',
        'web_edge',
    ],
    TV: ['stv', 'appletv', 'firetv', 'xbox', 'playstation', 'lgtv', 'samsung'],
};

export const COMPONENT_TYPES = {
    USER_WATCHLIST: 'UserWatchlist',
    VOD_CAROUSEL: 'VodCarousel',
    REWIND_CAROUSEL: 'RewindCarousel',
    STREAMING_CAROUSEL: 'StreamingCarousel',
    REWIND_LIST: 'RewindList',
    FEATURED_SLIDER: 'FeaturedSlider',
    VOD_FEATURED_CAROUSEL: 'VodFeaturedCarousel',
    FULLVOD_CATALOG_LIST: 'FullVODCatalogList',
    DETAILS_CONTAINER: 'DetailsContainer',
    CAST_CREW: 'CastCrew',
    SEASON_EPISODES: 'SeasonsEpisodes',
    SEARCH_RESULTS: 'SearchResults',
    CONTINIE_WATCHING: 'ContinueWatching',
    WATCHLIST_CAROUSEL: 'WatchlistCarousel',
    SEARCH_RECOMMENDATIONS: 'SearchRecommendations',
    TV_GUIDE_CAROUSEL: 'TvGuideCarousel',
    IMAGES_CAROUSEL: 'ImagesCarousel',
    EPISODES: 'Episodes',
    GENRES_CAROUSEL: 'GenresCarousel',
    ADDON_CAROUSEL: 'AddonCarousel',
    ADDONS_BANNER: 'AddonsBanner',
    MENU: 'MENU',
    SELECT_PROFILE: 'SelectProfile',
    GAMES_CAROUSEL: 'GamesCarousel',
};

export const ELEMENT_TYPES = {
    WATCHLIST_EPISODE_ITEM: 'EpisodeItem',
    WATCHLIST_VOD_ITEM: 'VodItem',
    WATCHLIST_LINEAR_ITEM: 'LinearItem',
    PERSON_ITEM: 'PersonItem',
    EPISODE_LOADER: 'EpisodeLoader',
};

export const BROWSER_TYPES = {
    UNKNOWN: 'Unknown',
    OPERA: 'Opera',
    FIREFOX: 'Firefox',
    SAFARI: 'Safari',
    EDGE: 'Edge',
    CHROME: 'Chrome',
    BRAVE: 'Brave',
};

export const VMX_DEVICE_TYPES = {
    Unknown: 'wcp',
    Opera: 'wcp',
    Firefox: 'wcp_firefox',
    Safari: 'wcp_safari',
    Edge: 'wcp_edge',
    Chrome: 'wcp_chrome',
    Brave: 'wcp_chrome',
};

export const PLATFORMS = {
    WINDOWS: 'Windows',
    IPHONE: 'iPhone',
    IPAD: 'iPad',
    ANDROID: 'Android',
    MAC: 'MacOS',
    LINUX: 'Linux',
    UNKNOWN: 'Unknown OS',
};

export const browserNotSupportedText = {
    TITLE_EN: config.browserSupport.textMessages.title_en,
    TITLE_AR: config.browserSupport.textMessages.title_ar,
    TEXT_EN: config.browserSupport.textMessages.text_en,
    TEXT_AR: config.browserSupport.textMessages.text_ar,
};

//https://docs.portal.theoplayer.com/docs/api-reference/theoplayer-mediaerrorcode
export const MEDIA_ERROR_CODE = {
    1: 'ABORTED',
    2: 'NETWORK',
    3: 'DECODE',
    4: 'SRC_NOT_SUPPORTED',
    5: 'ENCRYPTED',
    6: 'LICENSE_INVALID',
    7: 'ADVERTISEMENT_ERROR',
};

export const PROMO = {
    NO_CHARS_DESCRIPTION_EN: 2000,
    NO_CHARS_DESCRIPTION_AR: 2000,
    NO_CHARS_TITLE: 42,
    SEASON: 'S',
    EPISODE: ':E',
    NO_OF_EPISODE: ', E1—',
};
export const layoutTypes = {
    plainHTML: 'plain',
    article: 'article',
    accordion: 'accordion',
};
export const REWIND_DAYS = {
    TODAY: 'TODAY',
    YESTERDAY: 'YESTERDAY',
    TOMORROW: 'TOMORROW',
    TODAY_AR: 'اليوم',
    YESTERDAY_AR: 'أمس',
};
export const PARAMS = {
    refresh_seconds: '30',
    channels_count: '4',
};

export const CACHE_CONFIG_TYPES = {
    baseConfiguration: 'baseConfiguration.cache.object',
    configuration: 'configuration.cache.object',
    version: 'configuration.cache.version',
};

export const SUB_PACKAGE_STATUS_NAME = {
    active: 'ACTIVE',
};

export const FREE_SUB_PACKAGE_TYPES = {
    alacart_free: 'ALACARTE_FREE',
    add_on_free: 'ADD_ON_FREE',
};

export const SUB_PACKAGE_STATUS = {
    active: 'active',
    inactive: 'inactive',
};

export const SEARCH_API_KEYS = {
    search_api_key_b2c: 'key_ga_stg',
    search_api_key_b2b: 'key_ga_s_b2b',
    search_api_key_b2b2c: 'key_ga_s_b2b2c',
};

export const DIVE_API_KEYS = {
    api_key_b2c: 'gters8uqif',
    api_key_b2b: 'nx1xo7x39z',
    api_key_b2b2c: 'gters8uqif',
};

export const WATERMARK = {
    USER_TOKEN: (config.watermarkUserToken as string) || '',
};

export const KIDSMODE = {
    KID: 'kid',
    PARENT: 'parent',
};

export const CHANNEL_TYPES = {
    USER_CHANNEL_HISTORY: 'user_channel_history',
    STATIC_CAROUSEL: 'static_carousel',
    EMBED_CHANNELS: 'embed_channels',
};

export const parentalPinManagementConstants = {
    ADD: 'add',
    CHANGE: 'change',
    VALIDATE: 'validate',
    SET: 'set',
    ACCOUNT_RETRIEVAL_OTP_GENERATE: 'account-retrieval-otp-generate',
    ACCOUNT_RETRIEVAL_OTP_VALIDATE: 'account-retrieval-otp-validate',
    ACCOUNT_RETRIEVAL_PIN_VIEW: 'account-retrieval-pin-view',
    PARENTAL_LOCK_RESET_OTP: 'parental-lock-reset-otp',
    PARENTAL_LOCK_RESET_PIN: 'parental-lock-reset-pin',
    NOT_FOUND: 'not-found',
    KID_EXIT: 'kid-exit',
    KID_HOME: 'kid-home',
    ACCOUNT: 'account',
    PARENTAL_PIN: 'parentalPinScreen',
    CONSENT_MANAGEMENT: 'consent-management',
};

// B2C account-retrieval OTP (forgot pin) responses don't include an `otpLength`,
// so the digit-box count for that specific flow is fixed here.
export const B2C_ACCOUNT_RETRIEVAL_OTP_LENGTH = 6;
export const PARENTAL_LOCK_OTP_RESEND_COOLDOWN_SEC = 300;
export const PARENTAL_LOCK_OTP_RESEND_COOLDOWN_UNTIL_STORAGE_KEY = 'parental_lock_otp_resend_cooldown_until';
export const PARENTAL_LOCK_VERIFIED_OTP_STORAGE_KEY = 'parental_lock_verified_otp';
export const PARENTAL_LOCK_VERIFICATION_GUID_STORAGE_KEY = 'parental_lock_verification_guid';
export const PARENTAL_LOCK_VERIFIED_PARENTAL_PIN_STORAGE_KEY = 'parental_lock_verified_parental_pin';

export const RE_DIGIT = new RegExp(/^\d+$/);

export const LEARN_ACTION_CASE_IDS = {
    SEARCH_CLICK: 'search/search',
};

export const NAVIGATION = {
    GOBACKTO_PREVIOUS_SCREEN: -1,
};

export const PLACEHOLDERS = {
    USERNAME: 'UserName',
    COUNTRY: 'Country',
    DEVICE: 'Device',
    RATING: 'Rating',
    PROFILENAME: 'ProfileName',
    SUBGUIDS: 'SubGuids',
};

export const REMINDER = {
    REMINDER_CUTOFF_TIME: 10,
    REMINDER_LIMIT: 100,
};

export const PROVIDER = {
    WIDTH: 104,
    HEIGHT: 0,
    QUALITY: 100,
};

export const ROUTE_CONSTANT = {
    CONSENT_MANAGEMENT: 'consent-management',
    MOVIES: 'movies',
    SHOWS: 'shows',
    COLD_START: 'cold-start',
    KIDS_HOME: 'kids-home',
    SELECT_PROFILE: 'select-profile',
    LIVE_TV: 'livetv',
    EXIT_KID: 'exit-kid',
    PARENTAL_PIN_MANAGEMENT: 'parental-pin-management',
} as const;

export const MOODS_CONSTANT = {
    liveTV: 'livetv',
    lucky: 'lucky',
    tvshows: 'tvshows',
    movies: 'movies',
};

export const MOODS_MIXPANEL_CONSTANT = {
    livetv: 'Live TV',
    lucky: 'Feeling Lucky',
    movies: 'VOD',
    tvshows: 'VOD',
};

export const ITEM_CATEGORY = {
    VOD: 'VOD',
    LINEAR: 'LINEAR',
};

export const REMINDER_ITEM_CATEGORY = {
    VOD: 'VOD',
    LINEAR: 'LINEAR',
    PPV: 'PPV',
};

export const ITEM_TAG = {
    COMING_SOON: 'ComingSoon',
};

export const SCREEN_NAME_MAPPING = {
    en: 'Home',
    ar: 'Home',
    home: 'Home',
    movies: 'Movies',
    series: 'Series',
    sports: 'Sports',
    kids: 'Kids',
    profile: 'Profile',
    watchlist: 'Watchlist',
    shows: 'Shows',
    tvods: 'Tvods',
    rewind: 'Rewind',
    search: 'Search',
    settings: 'Settings',
    'select-profile': 'Select Profile',
    'add-profile': 'Add Profile',
    'edit-profile': 'Edit Profile',
    'parental-pin-management': 'Parental Pin Management',
    'cold-start': 'Cold Start',
    'catchup-player': 'Catchup Player',
    livetv: 'Live TV',
    play: 'Play',
    'consent-management': '',
    'profile-settings': '',
    'profile-history': 'Profile History',
    'kids-home': 'Kids Home',
    'vod-list': 'Vod List',
};

export const TIERS_NAME_CONFIG = {
    lite: 'Lite',
    classic: 'Classic',
    premium: 'Premium',
    free: 'Basic',
    plus: 'Premium',
};

export const CDN_BALANCER_BUCKETS = {
    LIVE: 'LIVE',
    VOD: 'VOD',
};

export const STREAM_HARNESS_SELECTOR_RESOLUTION = {
    client: 'client',
    server: 'server',
};

export const ZONE_TYPE = 'TA_ZONE';

export const LIVELIKE_DATA_SOURCES = {
    BACKEND: 'backend',
    SDK: 'sdk',
};
